import {
  GetTaskGroupTask,
  getTaskListByParas,
  getAllCurrentUserTask,
  GetTaskViewHistory,
  GetAllManageServerCenterByUserId,
  GetServerCenterByUserId,
  GetTaskLuneceQuery,
  GetTaskRelationByTaskId,
  GetAllTemplateByUserId,
  GetTaskListByTaskIdList,
  GetAllVisibleTemplateByUserId,
  GetAllServerCenterTask
} from '@/api/modules/basicData/task'
import Linq from 'linq';
import {
  getToken
} from '../../util/auth'
import searchJs from '../../util/search'
import {
  listToTree,
  listToTrees,
  getParent,
  getParents,
  GetTemplateFaultTypeSearchResultByTemplateID
} from '@/api/modules/basicData/commonData'
import {
  GetTemplateUserSearchResultByTemplateID
} from '@/api/modules/basicData/organization'

import CreateExecUsereObj from "@/components/basicTemplate/SelectCreateExecUser/CreateExecUserHelper.js"
import ObjectInstanceID from "@/components/basicTemplate/SelectDeviceObject/ObjectInstanceHelper.js"
import UserID from "@/components/basicTemplate/SelectUser/UserHelper.js"

import {
  stat
} from 'fs'
const cookieUser = getToken()
export default {
  state: {
    agencyWorkCount:0,//代办工作总条数
    dragId: '', //拖拽到模板的id值
    selectTaskList: [], //选中的任务 目前主要用到右键这块
    taskStyle: 0, //任务类型 0：任务 1：草稿 2：模板
    jumpIndex: "", //工作看板 首页跳转信息
    loading: false,
    isInfiniteScroll: false, //是否无限滚动
    rowId: '', // 修改结果集模板是table当前行的id
    isTemplateSearch: true, //是否面板检索
    columns: [],
    isLookRecord: true,
    category: 0, // 当前使用模板组件的类型
    tableData: [], // 编辑结果集页面的列表
    isExpand: false, // 判断是否展开右侧
    hhh: null, // tree的高亮显示
    lookRecordTree: [], // 浏览记录树
    allTemplate: [], // 所有模板
    allVisibleTem: [], //左侧展示的所有模板，--不是树结构
    taskRelation: [], //当前任务的任务关联列表 //任务详情使用
    rClick1: false,
    rClick2: false,
    rClick3: false,
    selectRadioType: 0, //0:任务组任务 1：工作记录
    allLeftTree: [], // 左侧所有个人模板
    temporary: [], //所有模板 除分组
    TemplateMenu: [], //菜单模板
    dormitory: [], //模板管理里面的赋值
    temClass: [], // 所有分组
    treeDataLeft: [], // 左侧树结构  --个人
    pendingTaskList: [], // 等待处理的任务集合
    isAllTask: false, //是否查看所有任务
    serviceCenterList: [], //所有服务台
    companyDeptIds: '', //我管理的服务台 逗号分隔
    seekOrTag: true,
    isDisabled: false,
    serviceCenterName: '',
    isDragArea: false,
    tagLength: 0, //模板长度
    tagType: true, //是否新增结果集
    tagItem: {},
    resultTagItem: {}, //当前选中的结果集
    userId: cookieUser.userId,
    account: cookieUser.account,
    realName: cookieUser.realName,
    companyName: cookieUser.companyName,
    taskParas: {
      CurrentUserId: cookieUser.userId,
      TypeIndex: -1,
      ExcuteState: '0',
      CreateClass: '1'
      // ServerCenterIds:'687b5e91209d2a44',
    },
    taskLuneceParas: {
      CurrentUserId: cookieUser.userId,
      KeyWord: '', //全文搜索关键字
      CreateUserId: '',
      ExcuteUserId: '',
      TaskState: '',
      ServerCenterId: '',
      Menu: '',
      TaskType: ''
    },
    taskReceptionParas: {
      /****服务台任务需要 */
      TypeIndex: '', //类型
      CurrentUserId: '', //用户ID
      ExcuteState: '', //状态
    },
    KeyWord: '', //全文搜索关键字
    pageIndex: 1,
    pageSize: 30,
    totalCount: 0,
    type: 0, //检索类型0：普通检索 1：全文检索
    curTask: {},
    taskDetailShow: false,
    taskSource: [], //任务列表
    taskClassList: [], //结果集分类
    tabIndex: '0',
    ServerCenterIds: '',
    ServerCenterDatas: [],
    ViewTypeName: "列表视图",
    viewType: 'folder',
    ViewTypeState: [{
        value: "list",
        name: "列表视图"
      },
      {
        value: "card",
        name: "卡片视图"
      },
      {
        value: "stat",
        name: "统计视图"
      },
      {
        value: "folder",
        name: "文件夹视图"
      },
      {
        value: "callerPhone",
        name: "来电号码视图"
      }
    ],
    TaskTypeByView: [],
    AnswerTypeState: [{
      name: '未接',
      value: '0'
    }, {
      name: '已接',
      value: '1'
    }], //接听类型
    SpecialTypeState: [{
      name: '未接',
      value: '0'
    }, {
      name: '已接',
      value: '1'
    }], //
    taskcontextMemu: [{
        fnHandler: 'createdTalk',
        icoName: 'fa   fa-wechat',
        btnName: '发起会话'
      },
      {
        fnHandler: 'urgeTask',
        icoName: 'fa fa-history fa-fw',
        btnName: '催办'
      },
      // {
      // 	fnHandler: 'focusTask',
      // 	icoName: 'fa fa-plus-circle fa-fw',
      // 	btnName: '设为关注任务'
      // },
      {
        fnHandler: 'addWorkRecord',
        icoName: 'fa fa-plus-circle fa-fw',
        btnName: '添加工作记录'
      },
      {
        fnHandler: 'Notification',
        icoName: 'fa fa-navicon fa-fw',
        btnName: '通知详情'
      },
      {
        fnHandler: 'TaskSummary',
        icoName: 'fa fa-plus-circle fa-fw',
        btnName: '任务总结'
      }
    ],
    createIdentity: [], // 创建身份的服务台集合
    taskGroupParas: {
      TaskName: '',
      TaskInstance: '',
      CreateUserId: '',
      ExcuteUserId: '',
      ExcuteState: '',
      CreateTime1: '',
      CreateTime2: '',
      PageIndex: 1,
      PageSize: 10
    },
    Person: {
      ID: cookieUser.userId,
      NAME: cookieUser.realName,
      DEPTID: cookieUser.departmentId,
      DEPTNAME: cookieUser.departmentName,
      COMPANYID: cookieUser.companyId,
      COMPANYNAME: cookieUser.companyName
    },
    taskGroupNative: [],
    taskGroupCurrent: [],
    taskGroupList: [],
    taskGropuParent: [], //所有父级
    templateTag: [],
    searchParams: {
      TaskStyle: 0,
      // tasktype:'',  //任务类型
      TaskInstance: '',
      EventInstance: '',
      ExcuteState: '0,1,2,3,5,-1',
      TaskName: '',
      CreateTime2: '',
      CreateTime1: '',
      CreateUser: {},
      ExcuteUser: {},
      TaskType: [],
      state: [],
      CreateClass: '1', //创建来源 0系统，1人為
      CreateSource: [], //报修来源
      TypeIndex: '',
      ServerCenterIds: '',
      TaskRightId: '',
      TaskDegree: [],
      AcceptTime1: '', //接收时间1
      AcceptTime2: '', //接收时间2
      CompleteTime1: '', //完成时间1
      CompleteTime2: '', //完成时间2
      TransferTime1: '', //流转时间1
      TransferTime2: '', //流转时间2
      CloseTime1: '', //关闭时间1
      CloseTime2: '', //关闭时间2
      OutDateTime1: '', //逾期时间1
      OutDateTime2: '', //逾期时间2
      LinkManId: '', //联系人
      TaskMemeberId: '', //干系人
      DeviceId: '', //设备信息 设备ID,设备类型
      FaultType: '', //故障类型
      Location: '', //故障地址
      LinkManIds: '', //联系人Id （逗号分隔）
      TaskMemeberIds: '', //干系人Id（逗号分隔）
      CreateUserIds: '', //创建人Id（逗号分隔）
      ExcuteUserIds: '', //执行人Id（逗号分隔）
      RoleType: '', //组织机构相关人人员（逗号分隔 1.创建人 2. 执行人 3.干系人 4.联系人 ）
      OutOfDate: '', //超期
      TaskClassCode: '',
      CallerPhone: '', //来电号码
      ANSWERPHONE: '', //接听分机
      ANSWERTYPE: '', //接听类型
      ANSWERUSERID: [], //接听人员
      OrderTime: 'ACTUALOPERATETIME', //排序方式
      TagIds: '', //任务标签
    },
    Alone: {}, //相关规定变量数据
    isCheckbox: false, // 是否使用复选框
    // treeData: [1,2]
    value: {},
    taskTypeOptions: [], //任务类型
    taskType: '',
    icons: [
      'icon-renwuzutai',
      'icon-comments',
      'icon-buchongziliao',
      'icon-liaotian',
      'icon-tianjiarenwu',
      'icon-28cuiban',
      'icon-task',
      'icon-zhoubaozongjie1',
      'icon-renwu',
      'icon-shanchu1',
      'icon-dahui',
      'icon-pingjia',
      'icon-jilu',
      'icon-zongjie',
      'icon-diannao',
      'icon-xiugaimima',
      'icon-task-add',
      'icon-tongzhi',
      'icon-shenpi',
      'icon-xiangqingcopy',
      'icon-add',
      'icon-tianjia',
      'icon-zhankai',
      'icon-cuiban',
      'icon-zidingyicanshuzhankaihou',
      'icon-shanchu'
    ],
    searchCriteria: {},
    stateOptions: [{
        //执行状态
        label: '待接收',
        value: 0
      },
      {
        label: '执行中',
        value: 1
      },
      {
        label: '已完成',
        value: 2
      },
      {
        label: '已关闭',
        value: 3
      },
      {
        label: '审批中',
        value: '4'
      },
      {
        label: '挂起中',
        value: 5
      },
      {
        label: '已作废',
        value: -1
      }
    ], //任务状态
    createClassOptions: [{
        label: '所有',
        value: ''
      },
      {
        label: '系统创建',
        value: '0'
      },
      {
        label: '人工创建',
        value: '1'
      }
    ], //创建来源
    createSourceOptions: [
      //报修来源
      {
        label: 'PC桌面',
        value: '0'
      },
      {
        label: '微信',
        value: '1'
      },
      {
        label: '电话',
        value: '2'
      },
      {
        label: '网站',
        value: '3'
      },
      {
        label: '邮件',
        value: '5'
      },
      {
        label: '监控',
        value: '6'
      },
      {
        label: '运维APP',
        value: '7'
      },
      {
        label: '统一桌面',
        value: '8'
      }
    ],
    typeIndexOptions: [
      //角色分类
      {
        label: '我接收的',
        value: '0'
      },
      {
        label: '我创建的',
        value: '1'
      },
      {
        label: '我分派的',
        value: '2'
      },
      {
        label: '我流转的',
        value: '3'
      },
      {
        label: '我参与的',
        value: '4'
      },
      {
        label: '我关注的',
        value: '5'
      }
    ],
    degreeOptions: [
      //任务等级
      {
        label: '重要且紧急',
        value: '0'
      },
      {
        label: '重要不紧急',
        value: '1'
      },
      {
        label: '紧急不重要',
        value: '2'
      },
      {
        label: '不重要不紧急',
        value: '3'
      }
    ],
    nowTagObg: {},
    realTimeObj: {},
    watchMore: 0,
    taskRow: {}, // 当前被点击任务信息
    searchCondition: [], // 搜索条件
    tempType: null, //模板类型
    folderInfo: {}, //选择任务组值
    userSerParms: {},
  },
  mutations: {
    setAgencyWorkCount(state,val){
      state.agencyWorkCount = val;
    },
    setTaskRelation(state, val) {
      state.taskRelation = val;
    },
    setDragId(state, dragId) { //赋值拖拽模板ID
      state.dragId = dragId;
    },
    setSelectTaskList(state, selectTaskList) { //赋值选中的数据
      state.selectTaskList = selectTaskList;
    },
    setTaskStyle(state, info) {
      state.taskStyle = info.TaskStyle ? info.TaskStyle : 0;
    },
    setFolderInfo(state, folderInfo) {
      state.folderInfo = folderInfo
    },
    setTempType(state, tempType) {
      state.tempType = tempType
    },
    setSearchParams(state, searchParams) {
      state.searchParams = searchParams
    },
    setViewTypeState(state, viewTypeState) {
      state.ViewTypeState = viewTypeState
    },
    setCompanyDeptIds(state, companyDeptIds) {
      state.companyDeptIds = companyDeptIds
    },
    setQueryTask(state, pars) {
      let Alone = {
        //单独动态判断的前提条件
        ExcuteMe: false, //执行人本人
        ConvertMe: false,
        CreateMe: false, //创建人本人
        LinkManMe: false, //联系人本人
        TaskMemeberMe: false, //干系人本人
        ConvertUserIds: [],
        meCompanyDept: true, //我参与的组织机构
        meServiceCenter: false, //我管理的服务台
        receiveTimeRange: [], //接收时间
        receiveTimeRadio: '', //接收时间选择
        receiveTimeInput: '', //接收时间填写
        receiveTimeDynamic: 1, //接收时间（小时,天，周，月）
        circulationtimeRange: [], //流转时间
        circulationtimeRadio: '', //流转时间选择
        circulationtimeInput: '', //流转时间填写
        circulationTimeDynamic: 1, //流转时间（小时,天，周，月）
        audittimeRange: [], //审批时间
        audittimeRadio: '', //审批时间选择
        audittimeInput: '', //审批时间填写
        auditTimeDynamic: 1, //审批时间（小时,天，周，月）
        completetimeRange: [], //完成时间
        completetimeRadio: '', //完成时间选择
        completetimeInput: '', //完成时间填写
        completeTimeDynamic: 1, //完成时间（小时,天，周，月）
        createtimeRange: [], //创建时间
        createtimeRadio: '', //创建时间选择
        createtimeInput: '', //创建时间填写
        createTimeDynamic: 1, //创建时间（小时,天，周，月）
        closetimeRange: [], //关闭时间
        closetimeRadio: '', //关闭时间选择
        closetimeInput: '', //关闭时间填写
        closeTimeDynamic: 1, //关闭时间（小时,天，周，月）
        overduetimeRange: [], //逾期时间
        overduetimeRadio: '', //逾期时间选择
        overduetimeInput: '', //逾期时间填写
        overduetimeDynamic: 1, //逾期时间（小时,天，周，月）
        companyDeptCheckList: [1, 2], //组织机构人员选择
        ExcuteUserIds: [], //控件中执行人Ids
        CreateUserIds: [], //控件中创建人Ids
        MemeberUserIds: [], //控件中干系人Ids
        LinkUserIds: [], //控件中联系人Ids
        TaskRightIds: [], //控件中组织机构Ids
        DeviceIds: [], //控件中设备Ids
        selectedCreateUser: [],
        selectedExcuteUser: [],
        ServerCenterIds: [], //服务台
        FaultType: [],
        stateName: '', //执行状态
        taskTypeName: '', //任务类型
        TaskDegreeName: '', //任务等级
        SourceName: '', //保修来源
        FaultTypeName: '', //故障类型名称
        DeviceName: '', //故障设备名称
        TypeIndexName: '', //角色分类
        CreateClassName: '', //创建来源
        TaskRightName: '', //组织机构名称
        ExcuteUserName: '', //执行人名称
        CreateUserName: '', //创建人名称
        MemeberUserName: '', //干系人名称
        LinkUserName: '', //联系人名称
        ServerCenterName: '', //服务台名称
        TaskRightTypes: [], //组织机构加type，防止出现多个
        OutOfDateName: '', //超期名称
        IsStateCondition: false,
        IsTeamCondition: false,
        TaskClass: '',
        typeView: 0,
        serviceDesk: '',
        ViewType: '',
        ViewTypeName: '',
        AnswerUserName: '', //接听人名称
        AnswerTypeName: '', //接听类型名称
        TagIds: [], //任务标签
        orderRule: 'DESC',
        OrderTime: 'ACTUALOPERATETIME',
      }
      let searchParams = {
        TaskInstance: '',
        EventInstance: '',
        ExcuteState: '',
        TaskName: '',
        CreateTime2: '',
        CreateTime1: '',
        CreateUser: {},
        ExcuteUser: {},
        TaskType: [],
        state: [],
        CreateClass: '', //创建来源 0系统，1人為
        CreateSource: [], //报修来源
        TypeIndex: '',
        ServerCenterIds: '',
        TaskRightId: '',
        TaskDegree: [],
        AcceptTime1: '', //接收时间1
        AcceptTime2: '', //接收时间2
        CompleteTime1: '', //完成时间1
        CompleteTime2: '', //完成时间2
        TransferTime1: '', //流转时间1
        TransferTime2: '', //流转时间2
        CloseTime1: '', //关闭时间1
        CloseTime2: '', //关闭时间2
        OutDateTime1: '', //逾期时间1
        OutDateTime2: '', //逾期时间2
        LinkManId: '', //联系人
        TaskMemeberId: '', //干系人
        DeviceId: '', //设备信息 设备ID,设备类型
        FaultType: '', //故障类型
        Location: '', //故障地址
        LinkManIds: '', //联系人Id （逗号分隔）
        TaskMemeberIds: '', //干系人Id（逗号分隔）
        CreateUserIds: '', //创建人Id（逗号分隔）
        ExcuteUserIds: '', //执行人Id（逗号分隔）
        RoleType: '', //组织机构相关人人员（逗号分隔 1.创建人 2. 执行人 3.干系人 4.联系人 ）
        OutOfDate: '', //超期
        TaskClassCode: '',
        CallerPhone: '',
        ANSWERPHONE: '', //接听分机
        ANSWERTYPE: '', //接听类型
        ANSWERUSERID: [], //接听人员
        OrderTime: 'ACTUALOPERATETIME',
        TagIds: '', //任务标签
      }
      if (pars.isEmpty == true) {
        state.searchParams = searchParams
        state.Alone = Alone
      } else {
        let query = Object.assign({}, searchParams)
        Object.assign(query, pars)
        query.Alone = Alone
        Object.assign(query.Alone, pars.Alone)
        pars = searchJs.serachTaskDisplay(query)
        console.log('setQueryTask', query);

        state.searchParams = query
        state.Alone = query.Alone
      }
    },
    redact(state, val) {
      // 编辑模板
      if (val.TEMPTYPE == 1) {
        // 结果集
        state.rowId = 'ID'
        if (val.CATEGORY == 0) {
          GetTaskListByTaskIdList(val.CONTENT, state.userId).then(res => {
            state.tableData = res
            state.rowId = 'ID'
          })
        }
        // else if (val.CATEGORY == 6) {
        //   GetTemplateUserSearchResultByTemplateID(val.ID, state.userId).then(
        //     res => {
        //       state.tableData = res
        //       state.rowId = 'ID'
        //     }
        //   )
        // }
        else if (val.CATEGORY == 9) {
          GetTemplateFaultTypeSearchResultByTemplateID(
            val.ID,
            state.userId
          ).then(res => {
            state.tableData = res
            state.rowId = 'Id'
          })
        } else if (val.CATEGORY == 14) { //任务创建、执行对象
          GetTemplateCreateExecUserSearchByTemplateID(val.ID, cookieUser.userId).then(res => {
            //格式[{"ID":"1","Type":1,"CreateExecType":0},{"ID":"ed16704de6992b2d","Type":3,"CreateExecType":0}]
            res.forEach(s => s.SpecialKey = new CreateExecUsereObj({
              ID: s.SocialId,
              Type: s.Type,
              CreateExecType: s.CreateExecType
            }));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          });
        } else if (val.CATEGORY == 16) { //运维对象实例

          GetTemplateDeviceObjectSearchByTemplateID(val.ID, cookieUser.userId).then(res => {

            res.forEach(s => s.SpecialKey = new ObjectInstanceID({
              ID: s.SocialId,
              Type: s.Type
            }));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          })
        } else if (val.CATEGORY == 6) { //人员
          GetTemplateUserSearchResultByTemplateID(val.ID, state.userId).then(res => {
            res.forEach(s => s.SpecialKey = new UserID({
              ID: s.ID,
              Type: s.Type
            }));
            state.tableData = res;
            state.rowId = 'SpecialKey';
          });
        }
      } else {
        // 搜索模板
        if (val.CATEGORY == 0) {
          console.log("任务类型");
          let content = JSON.parse(val.CONTENT)
          this.commit('setQueryTask', content)
        } else if (val.CATEGORY == 6) {
          console.log("人员类型", JSON.parse(val.CONTENT));

        }

      }
    },
    // createSearchTemp(state, data) {
    // 	if (state.category == 0) {
    // 		// this.$refs.TaskSearch.SearchOpen(data)
    // 		state.tempType = data;
    // 	} else if (state.category == 7) {
    // 		// this.$refs.TaskGroupSearch.SearchOpen(data)
    // 		state.tempType = data;
    // 	}
    // },
    setSelectRadioType(state, selectRadioType) {
      state.selectRadioType = selectRadioType
    },
    setTaskGroupCurrentData(state, info) {
      let index = Linq.from(state.taskGropuParent).indexOf(x => x.ID == info.row.ID);
      console.log('index', index);
      if (index >= 0) {
        state.taskGropuParent = Linq.from(state.taskGropuParent).take(index + 1).toArray();
      } else {
        let taskGropuParent = state.taskGropuParent;
        taskGropuParent.push(info.row);
        state.taskGropuParent = taskGropuParent
      }
      state.taskGroupCurrent = info.taskGroupCurrent
    },
    setTaskGroupCurrent(state, id) {
      if (id) {
        state.taskGropuParent = getParent(state.taskGroupList, id)
        state.taskGroupCurrent = state.taskGroupNative.filter(
          p => p.PARENTID === id
        )
      } else {
        state.taskGropuParent = []
        state.taskGroupCurrent = state.taskGroupNative.filter(p => !p.PARENTID)
      }
    },
    setTaskGroupCurrents(state, id) {
      if (id) {
        state.taskGropuParent = getParents(state.taskGroupList, id)
        state.taskGroupCurrent = state.taskGroupNative.filter(
          p => p.PARENTID === id
        )
      } else {
        state.taskGropuParent = []
        state.taskGroupCurrent = state.taskGroupList
      }
    },
    // setTaskGroupReturn(state,ID){
    //   state.taskGroupCurrent = taskGroupCurrent;
    // },
    getNowSeek(state, needObj) {
      var obj = {
        任务编号: needObj.val.TaskInstance,
        任务名称: needObj.val.TaskName,
        执行人: needObj.val.ExcuteUser.NAME ? needObj.val.ExcuteUser.NAME : '',
        创建人: needObj.val.CreateUser.NAME ? needObj.val.CreateUser.NAME : '',
        执行状态: [],
        任务类型: [],
        任务等级: [],
        服务台: [],
        创建来源: [],
        报修来源: [],
        角色分类: [],
        创建时间: needObj.val.CreateTime1 != '' ?
          needObj.val.CreateTime1 + '至' + needObj.val.CreateTime2 : ''
      }
      state.stateOptions.forEach(a => {
        needObj.val.ExcuteState.split(',').forEach(c => {
          if (a.value == c) {
            obj.执行状态.push(a.label)
          }
        })
      })
      obj['执行状态'] = obj['执行状态'].toString()

      state.taskTypeOptions.forEach(a => {
        needObj.val.TaskType.split(',').forEach(c => {
          if (a.ID == c) {
            obj.任务类型.push(a.NAME)
          }
        })
      })
      obj['任务类型'] = obj['任务类型'].toString()

      state.degreeOptions.forEach(a => {
        needObj.val.TaskDegree.split(',').forEach(c => {
          if (a.value == c) {
            obj.任务等级.push(a.label)
          }
        })
      })
      obj['任务等级'] = obj['任务等级'].toString()

      state.serviceCenterList.forEach(a => {
        needObj.val.ServerCenterIds.split(',').forEach(c => {
          if (a.ID == c) {
            obj.服务台.push(a.NAME)
          }
        })
      })
      obj['服务台'] = obj['服务台'].toString()

      state.createClassOptions.forEach(a => {
        needObj.val.CreateClass.split(',').forEach(c => {
          if (a.value == c) {
            obj.创建来源.push(a.label)
          }
        })
      })
      obj['创建来源'] = obj['创建来源'].toString()

      state.createSourceOptions.forEach(a => {
        needObj.val.CreateSource.split(',').forEach(c => {
          if (a.value == c) {
            obj.报修来源.push(a.label)
          }
        })
      })
      obj['报修来源'] = obj['报修来源'].toString()

      state.typeIndexOptions.forEach(a => {
        needObj.val.TypeIndex.split(',').forEach(c => {
          if (a.value == c) {
            obj.角色分类.push(a.label)
          }
        })
      })
      obj['角色分类'] = obj['角色分类'].toString()

      if (needObj.num == 0) {
        state.nowTagObg = obj
      } else {
        state.realTimeObj = obj
      }
    },
    getTemplate(state, value) {
      var a = JSON.parse(value.CONTENT)
      state.searchCriteria = a
      state.searchParams = {
        TaskInstance: a.TaskInstance,
        EventInstance: a.EventInstance,
        ExcuteState: a.ExcuteState,
        TaskName: a.TaskName,
        CreateTime2: '',
        CreateTime1: '',
        CreateUser: a.CreateUser,
        ExcuteUser: a.ExcuteUser,
        TaskType: a.TaskType,
        state: a.state,
        CreateClass: a.CreateClass, //创建来源 0系统，1人為
        CreateSource: a.CreateSource.split(','), //报修来源
        TypeIndex: a.TypeIndex == -1 ? '' : a.TypeIndex,
        ServerCenterIds: a.ServerCenterIds,
        TaskRightId: a.TaskRightId,
        TaskDegree: a.TaskDegree.split(',')
      }
      this.commit('taskTypeChange', a.TaskType.split(','))

      this.dispatch('changeTaskParas', a)
    },
    taskTypeChange(state, vId) {
      //任务类型
      var arr = []
      state.taskTypeOptions.forEach(a => {
        vId.forEach(c => {
          if (a.value == c) {
            arr.push(a.label)
          }
        })
      })
      state.taskType = arr.join(',')
    },
    changeTaskDetailShow(state, show) {
      state.taskDetailShow = show
    },
    changeTaskParas(state, pars) {
      // alert(2)
      pars.CurrentUserId = cookieUser.userId
      state.taskParas = pars
    },
    changeTaskReceptionParas(state, pars) {
      state.taskReceptionParas = pars
    },
    changeLuneceTaskParas(state, pars) {
      // alert(1)
      pars.CurrentUserId = cookieUser.userId
      state.taskLuneceParas = pars
    },
    changeCurTask(state, task) {
      state.curTask = task
    },
    changeKeyWord(state, KeyWord) {
      state.KeyWord = KeyWord
    },
    changePageIndex(state, index) {
      state.pageIndex = index
    },
    changePageSize(state, size) {
      state.pageSize = size
    },
    changeTotalCount(state, count) {
      state.totalCount = count
    },
    changeTaskSource(state, source) {
      state.taskSource = source
      state.type = 0
    },
    changeLuneceTaskSource(state, source) {
      state.taskSource = source
      state.type = 1
    },
    changeTaskClassList(state, classList) {
      state.taskClassList = classList
    },
    changeServerCenterIds(state, server) {
      state.ServerCenterIds = server
    },
    changeServerCenterDatas(state, serverData) {
      state.ServerCenterDatas = serverData
    },
    changetabIndex(state, index) {
      state.tabIndex = index
    },
    changeType(state, type) {
      state.type = type
    },
    resettaskGroupParas(state) {
      // 重置任务组参数
      state.taskGroupParas = {
        TaskName: '',
        TaskInstance: '',
        CreateUserId: '',
        ExcuteUserId: '',
        ExcuteState: '',
        CreateTime1: '',
        CreateTime2: '',
        PageIndex: 1,
        PageSize: 10
      }
    },
    getAllTemplateLeft(state, isLoadMenu) {
      GetAllVisibleTemplateByUserId(state.userId, state.category).then(data => {
        //获取左侧所有模板
        // data.forEach((c) => {
        // 	if (c.TEMPTYPE != 2 && !c.PID) {
        // 		c.PID = 'zzz'
        // 	}
        // })
        let temClass = []
        data.forEach(c => {
          if (c.TEMPTYPE == 2 || c.TEMPTYPE == 4) {
            temClass.push(c)
          }
        })
        state.temClass = temClass
        let arr = []

        let sortData = data.sort((a, b) => {
          return a.ORDERINDEX - b.ORDERINDEX;
        });
        state.allVisibleTem = sortData
        let lookRecordTree = [{
          ICON: '任务一览.png',
          ROLETYPE: 0,
          TEMPTYPE: -1,
          VISIBLE: true,
          CONTENT: '',
          ID: '',
          NAME: '浏览记录',
          ISDEFAULT: false
        }, {
          ICON: '任务一览.png',
          ROLETYPE: 0,
          TEMPTYPE: -6,
          VISIBLE: true,
          CONTENT: '',
          ID: '',
          NAME: '草稿箱',
          ISDEFAULT: false
        }, {
          ICON: '任务一览.png',
          ROLETYPE: 0,
          TEMPTYPE: -7,
          VISIBLE: true,
          CONTENT: '',
          ID: '',
          NAME: '操作记录',
          ISDEFAULT: false
        }]
        sortData.forEach(c => {
          if (c.NAME !== '浏览记录' && c.NAME !== '计划管理') {
            arr.push(c)
          } else {
            lookRecordTree = []
            lookRecordTree.push(c)
          }
        })
        let menu = arr.filter(item => item.TEMPTYPE == 5 || item.TEMPTYPE == 6);
        if (state.TemplateMenu.length == 0 || isLoadMenu) {
          state.TemplateMenu = Linq.from(menu).orderBy(item => item.CREATETIME).toArray();
        }
        arr = arr.filter(item => item.TEMPTYPE != 5 && item.TEMPTYPE != 6); //去掉自定义模板
        //修改人杨，后期改为后台配置
        lookRecordTree.forEach(z => {
          z.label = z.NAME
          z.id = z.ID
        })
        arr.forEach(c => {
          c.label = c.NAME
          c.id = c.ID
        })
        let indexArr = []
        state.lookRecordTree = lookRecordTree
        indexArr = listToTree('ID', 'PID', arr)
        // indexArr.sort(function(a, b) {
        //   return b.ORDERINDEX > a.ORDERINDEX ? -1 : 1
        // })
        // indexArr.forEach(val => {
        //   if (val.children) {
        //     val.children.sort(function(a, b) {
        //       return b.ORDERINDEX > a.ORDERINDEX ? -1 : 1
        //     })
        //   }
        // })
        state.treeDataLeft = indexArr
      })
    },
    setIsCheckbox(state, isCheckbox) {
      state.isCheckbox = isCheckbox
    },
    getTaskGroup(state, Items) {
      // const list = JSON.parse(JSON.stringify(Items))
      state.taskGroupList = listToTrees('ID', 'PARENTID', Items)
      state.taskGroupNative = Items
      state.taskGroupCurrent = Items //.filter(p => !p.PARENTID)
    }
  },
  actions: {
    // 		getAllTemplate({
    // 			state
    // 		}) {
    // 			return new Promise((resolve, reject) => {
    // 				GetAllTemplateByUserId(state.userId).then(data => {//获取所有模板
    // 					data.forEach((c) => {
    // 						if (c.TEMPTYPE != 2 && !c.PID) {
    // 							c.PID = 'zzz'
    // 						}
    // 					})
    // 					state.allTemplate = data;
    // 					state.temClass = [{
    // 						pid: '',
    // 						NAME: '默认分组',
    // 						ID: 'zzz',
    // 						TEMPTYPE: 2,
    // 						ICON: 'icon-shenpi'
    // 					}];
    // 					state.temporary = [];
    // 					let taskNameArr = [];
    // 					data.forEach((c) => {
    // 						if (c.TEMPTYPE == 1) {
    // 							GetTaskListByTaskIdList(c.CONTENT, state.userId).then((res) => {
    // 								res.forEach((z) => {
    // 									taskNameArr.push(z.TASKNAME);
    // 								})
    //
    // 								c.nameArr = taskNameArr
    // 							})
    // 						}
    // 					})
    // 					data.forEach((c) => {
    // 						if (c.TEMPTYPE == 2 && c.NAME !== '浏览记录') {
    // 							state.temClass.push(c)
    // 						} else if (c.NAME !== '浏览记录') {
    // 							state.temporary.push(c)
    // 						}
    // 					})
    // 					resolve()
    // 				}).catch(error => {
    // 					reject(error)
    // 				})
    // 			});
    // 		},
    GetTaskRelation({
      state,
      commit
    }) {
      var id = state.curTask.ID;
      GetTaskRelationByTaskId(id).then(result => {
        commit("setTaskRelation", result);
      });
    },
    GetTaskGroupTaskList({
      state,
      dispatch,
      commit
    }, info) {
      state.loading = true;
      var paras = state.taskGroupParas
      if (info) {
        paras = Object.assign(paras, info)
      }
      GetTaskGroupTask(paras).then(res => {
        state.loading = false;
        if (res && res.Items) {
          // const list = [];//...res.Items
          const list = JSON.parse(JSON.stringify(res.Items))
          commit('changeTotalCount', res.TotalItems)
          commit('changeType', 3)
          // Object.assign(list,res.Items)
          state.taskGroupList = listToTree('ID', 'PARENTID', list)
          state.taskGroupNative = res.Items
          state.taskGroupCurrent = state.taskGroupList //res.Items.filter(p => !p.PARENTID)
        }
      })
    },
    changeTaskDetailShow({
      commit
    }, show) {
      commit('changeTaskDetailShow', show)
    },
    changeTaskParas({
      commit,
      dispatch
    }, pars) {
      pars.TaskStyle = pars.TaskStyle ? pars.TaskStyle : 0;
      commit('changeTaskParas', pars)
      commit('setSearchParams', pars)
      commit('setTaskStyle', pars)
      commit('changePageIndex', 1)
      commit('changeType', 0)
      dispatch('changeTaskSource')
    },
    changeTaskReceptionParas({
      commit,
      dispatch
    }, pars) {
      commit('changeTaskReceptionParas', pars)
      commit('changePageIndex', 1)
      commit('changeType', 3)
      dispatch('changeTaskReceptionSource')
    },
    changeLuneceTaskParas({
      commit,
      dispatch
    }, pars) {
      commit('changeKeyWord', pars.KeyWord)
      commit('changeLuneceTaskParas', pars)
      commit('changePageIndex', 1)
      commit('changeType', 1)
      dispatch('changeLuneceTaskSource')
    },
    changeCurTask({
      commit
    }, task) {
      commit('changeCurTask', task)
    },
    changePageIndex({
      commit,
      dispatch
    }, row) {
      commit('changePageIndex', row.index)
      if (row.type === 1) dispatch('changeLuneceTaskSource')
      else if (row.type === 2) dispatch('changeHistory')
      else if (row.type === 3) dispatch('changeTaskReceptionSource')
      else dispatch('changeTaskSource')
    },
    changePageSize({
      commit,
      dispatch
    }, row) {
      commit('changePageSize', row.size)
      if (row.type === 1) dispatch('changeLuneceTaskSource')
      else if (row.type === 2) dispatch('changeHistory')
      else if (row.type === 3) dispatch('changeTaskReceptionSource')
      else dispatch('changeTaskSource')
    },
    changeScrollPageIndex({
      commit,
      dispatch
    }, row) {
      commit('changePageIndex', row.index)
      if (row.type === 1) dispatch('changeScrollLuneceTaskSource')
      else if (row.type === 2) dispatch('changeScrollHistory')
      else if (row.type === 3) dispatch('changeTaskReceptionSource')
      else dispatch('changeScrollTaskSource')
    },
    changeHistory({
      commit,
      state
    }) {
      state.loading = true;
      let person = {
        ID: cookieUser.userId,
        NAME: cookieUser.realName,
        DEPTID: cookieUser.departmentId,
        DEPTNAME: cookieUser.departmentName,
        COMPANYID: cookieUser.companyId,
        COMPANYNAME: cookieUser.companyName
      }
      return new Promise((resolve, reject) => {
        GetTaskViewHistory(state.pageIndex, state.pageSize, person)
          .then(data => {
            if (data) {
              state.loading = false;
              commit('changeTaskSource', data.Items)
              commit('changeTotalCount', data.TotalItems)
              commit('changeType', 2)
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    changeScrollHistory({
      commit,
      state
    }) {
      state.loading = true;
      let person = {
        ID: cookieUser.userId,
        NAME: cookieUser.realName,
        DEPTID: cookieUser.departmentId,
        DEPTNAME: cookieUser.departmentName,
        COMPANYID: cookieUser.companyId,
        COMPANYNAME: cookieUser.companyName
      }
      return new Promise((resolve, reject) => {
        GetTaskViewHistory(state.pageIndex, state.pageSize, person)
          .then(data => {
            if (data) {
              state.loading = false;
              data.Items = data.Items ? data.Items : []; //如果没有items，就设为空数组防止出错
              state.taskSource = state.taskSource.concat(data.Items)
              commit('changeTotalCount', data.TotalItems)
              commit('changeType', 2)
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    changetabIndex({
      commit,
      dispatch
    }, index) {
      commit('changetabIndex', index)
    },
    changeServerCenterIds({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        GetAllManageServerCenterByUserId(cookieUser.userId)
          .then(data => {
            if (data) {
              const curUserServerCenters = data.map(function(item) {
                return item.ID
              })
              commit('changeServerCenterDatas', data)
              commit('changeServerCenterIds', curUserServerCenters)
              return
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetServerCenterByUserId({
      state,
      rootState
    }) {
      GetServerCenterByUserId(
        state.userId,
        rootState.user.realName,
        rootState.user.departmentId,
        rootState.user.departmentName
      ).then(res => {
        res.unshift({
          CENTERNAME: '个人',
          SERVERCENTERID: '0'
        })
        state.createIdentity = res
      })
    },
    changeTaskSource({
      commit,
      state
    }) {
      state.loading = true;
      let paras = {
        PageIndex: state.pageIndex,
        PageSize: state.pageSize,
        TypeIndex: -1,
        TaskParas: state.taskParas
      }
      return new Promise((resolve, reject) => {
        getAllCurrentUserTask(paras)
          .then(data => {
            if (data) {
              state.loading = false;
              state.taskGropuParent = [];
              if (data.Items) {
                commit('changeTaskSource', data.Items)
              } else {
                commit('changeTaskSource', [])
              }
              if(paras.TaskParas.isAgencyWork){//代办工作
                commit("setAgencyWorkCount",data.TotalItems)
              }
              commit('changeTotalCount', data.TotalItems)
              commit('changeType', 0)
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    //获取代办工作总数
    changeAgencyWork({
      commit,
      state
    }) {
      let paras = {
        PageIndex: 1,
        PageSize: 1,
        TypeIndex: -1,
        TaskParas: state.taskParas
      }
      return new Promise((resolve, reject) => {
        getAllCurrentUserTask(paras)
          .then(data => {
            if (data) {
              state.agencyWorkCount=data.TotalItems;
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    changeTaskReceptionSource({
      commit,
      state
    }) {
      state.loading = true;
      let paras = {
        PageIndex: state.pageIndex,
        PageSize: state.pageSize,
        TaskParas: state.taskReceptionParas
      }
      return new Promise((resolve, reject) => {
        GetAllServerCenterTask(paras)
          .then(data => {
            if (data) {
              state.loading = false;
              commit('changeTaskSource', data.Items)
              commit('changeTotalCount', data.TotalItems)
              commit('changeType', 3)
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    changeScrollTaskSource({
      commit,
      state
    }) {
      state.loading = true;
      let paras = {
        PageIndex: state.pageIndex,
        PageSize: state.pageSize,
        TypeIndex: -1,
        TaskParas: state.taskParas
      }
      return new Promise((resolve, reject) => {
        getAllCurrentUserTask(paras)
          .then(data => {
            if (data) {
              state.loading = false;
              data.Items = data.Items ? data.Items : []; //如果没有items，就设为空数组防止出错
              // state.taskSource.splice(paras.PageIndex*paras.pageSize, 1, data.Items);
              state.taskSource = state.taskSource.concat(data.Items)
              // commit('changeTaskSource', data.Items)
              commit('changeTotalCount', data.TotalItems)
              commit('changeType', 0)
              return
            }
            resolve()
          })
          .catch(error => {
            state.loading = false;
            reject(error)
          })
      })
    },
    changeLuneceTaskSource({
      commit,
      state
    }) {
      state.loading = true;
      let paras = {
        PageIndex: state.pageIndex,
        PageSize: state.pageSize,
        Para: state.searchParams, //state.taskLuneceParas,
        KeyWord: state.KeyWord //state.taskLuneceParas.KeyWord
        // CurrentUserId:state.taskLuneceParas.CurrentUserId,
        // CreateUserId:state.taskLuneceParas.CreateUserId,
        // ExcuteUserId:state.taskLuneceParas.ExcuteUserId,
        // TaskState:state.taskLuneceParas.TaskState,
        // ServerCenterId:state.taskLuneceParas.ServerCenterId,
        // Menu:state.taskLuneceParas.Menu,
        // TaskType:state.taskLuneceParas.TaskType,
      }
      GetTaskLuneceQuery(paras)
        .then(data => {
          if (data) {
            state.loading = false;
            commit('changeTaskSource', data.ResultList.Items)
            commit('changeTotalCount', data.ResultList.TotalItems)
            commit('changeTaskClassList', data.ResultClassificationList)
            commit('changeType', 1)
            return
          }
          // resolve()
        })
        .catch(error => {
          state.loading = false;
          console.log(error)
          // reject(error)
        })
    },
    changeScrollLuneceTaskSource({
      commit,
      state
    }) {
      state.loading = true;
      let paras = {
        PageIndex: state.pageIndex,
        PageSize: state.pageSize,
        Para: state.searchParams, //state.taskLuneceParas,
        KeyWord: state.KeyWord //state.taskLuneceParas.KeyWord
        // CurrentUserId:state.taskLuneceParas.CurrentUserId,
        // CreateUserId:state.taskLuneceParas.CreateUserId,
        // ExcuteUserId:state.taskLuneceParas.ExcuteUserId,
        // TaskState:state.taskLuneceParas.TaskState,
        // ServerCenterId:state.taskLuneceParas.ServerCenterId,
        // Menu:state.taskLuneceParas.Menu,
        // TaskType:state.taskLuneceParas.TaskType,
      }
      GetTaskLuneceQuery(paras)
        .then(data => {
          if (data) {
            state.loading = false;
            data.ResultList.Items = data.ResultList.Items ? data.ResultList.Items : []; //如果没有items，就设为空数组防止出错
            state.taskSource = state.taskSource.concat(data.ResultList.Items)
            // commit('changeTaskSource', data.ResultList.Items)
            commit('changeTotalCount', data.ResultList.TotalItems)
            commit('changeTaskClassList', data.ResultClassificationList)
            commit('changeType', 1)
            return
          }
          // resolve()
        })
        .catch(error => {
          state.loading = false;
          console.log(error)
          // reject(error)
        })
    },
    //TODO:任务审批数据
    ChangeApproveSource({
      commit,
      state
    }, data) {
      if (data) {
        commit('changeTaskSource', data)
      }
    },
  }
}
